import * as React from "react"
import {
  Container,
  Flex,
  FlexList,
  Box,
  Space,
  NavLink,
  Text,
  VisuallyHidden, Subhead, Button,
} from "../ui"
import BrandLogo from "../brand-logo"
import {useTranslation} from "gatsby-plugin-react-i18next";
import {Mail, Linkedin} from "react-feather";
import {theme} from "../../theme/theme.css";

// function validateEmail(email) {
//   let re = /\S+@\S+\.\S+/;
//   return re.test(email);
// }

export default function Footer() {
  const { t } = useTranslation();

  let links = [
    {
      "id": "a45bf3ae-6f44-5ef9-b081-d38fdde76ff8",
      "navItemType": "Link",
      "href": "#platforma",
      "text": "O nas"
    },
    {
      "id": "63f6b1bb-6887-5cc9-992f-316d6977793d",
      "navItemType": "Link",
      "href": "#funkcjonalnosci",
      "text": "Funkcjonalności"
    },
    {
      "id": "75affd84-e36a-50de-84ed-f19e8043317d",
      "navItemType": "Link",
      "href": "#kontakt",
      "text": "Kontakt"
    },
    {
      "id": "75affd84-e36a-50de-84ed-f19e8043317d",
      "navItemType": "Scroll",
      "href": "#demo-platformy",
      "text": "Zobacz demo"
    }
  ]
  let meta = [
    // {
    //   "id": "83350899-bd29-5a41-b5ef-0af3ae95c51b",
    //   "href": "/terms",
    //   "text": "Regulamin"
    // },
    {
      "id": "dcf0c9e6-a7e1-5f23-a833-ff9f7ca8ed90",
      "href": "/polityka-prywatnosci.pdf",
      "text": "Polityka Prywatności"
    },
    {
      "id": "fdsm0c9e6-d7e1-5fd3-a833-asd9f7ca8ed90",
      "href": "/regulamin.pdf",
      "text": "Regulamin"
    }
  ]

  let copyright = "©2023 ZnajdźZastępstwo"


  //
  // const [email, setEmail] = React.useState("")
  // const [formMsg, setFormMsg] = React.useState("")
  // const [btnDisabled, setBtnDisabled] = React.useState(false)

  // async function handleSubmit(e) {
  //   e.preventDefault();
  //   if(btnDisabled === true) return
  //
  //   let url = "https://us21.list-manage.com/subscribe/post-json?u=8a83d131802449193ffe7c930&id=fbb24cd549&f_id=001bd9e6f0&subscribe=Subscribe"
  //
  //   if (validateEmail(email) === false) {
  //     setFormMsg(t("common.invalid_email"))
  //     return
  //   }
  //   setBtnDisabled(true)
  //   setFormMsg(t("common.sending"))
  //   url = `${url}&EMAIL=${email}`
  //   await fetch(url, {
  //     method: "GET",
  //     mode: "no-cors",
  //   });
  //   setFormMsg(t("common.thanks_for_joining"))
  // }
  //
  // function onEmailInputChange(e) {
  //   setEmail(e.target.value)
  //   setFormMsg("")
  // }


  return (
    <Box id="kontakt" as="footer" paddingY={4} style={{marginTop: '2rem', position: 'relative', overflow: 'hidden'}}>

      <Container>
        <Flex variant="start" responsive style={{justifyContent: 'space-between', alignItems: 'stretch'}}>
          <Box width="third" style={{alignSelf: 'center'}}>
            <Subhead>
              {t("index.contact")}
            </Subhead>
            <Text as="p">{t("index.contact_info")}</Text>
            <Text style={{textDecoration: 'underline', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '1rem'}}>
              <Mail/>
              kontakt@znajdzzastepstwo.pl
            </Text>
            <a
              style={{textDecoration: 'underline', fontSize: '18px', display: 'flex', alignItems: 'center', gap: '1rem', color: theme.colors.text}}
              href="https://www.linkedin.com/company/znajdzzastepstwo/about/"
              target="_blank"
              rel="noreferrer"
            >
              <Linkedin/>
              ZnajdźZastępstwo
            </a>
          </Box>
          <div style={{
            position: 'relative',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}>
            <div
              style={{
                height: '100%',
                width: '1px',
                backgroundColor: theme.colors.primary,
                opacity: 0.5,
                position: "absolute",
                zIndex: -1
              }}
            />
            <p style={{backgroundColor: theme.colors.muted, padding: '0.5rem'}}>albo</p>
          </div>
          <Box width="third">
            <Subhead>
              {t("index.waitlist")}
            </Subhead>
            <Text as="p">
              Rejestracja na platformie jest darmowa, a dostęp uzyskuje się po szybkiej weryfikacji.
              Chcesz poznać nowe możliwości rynku zastępstw procesowych? Dołącz do nas już dziś.
            </Text>
            <Flex responsive alignItems="start">
              <div><Button to="https://platforma.znajdzzastepstwo.pl/register">Zarejestruj się</Button></div>
              <div><Button variant="linkReversed" to="/umow-demo">Umów spotkanie</Button></div>
            </Flex>


            {/*<div*/}
            {/*  className={inputCtn}*/}
            {/*>*/}
            {/*  <input*/}
            {/*    className={inputText}*/}
            {/*    value={email}*/}
            {/*    onChange={(e) => onEmailInputChange(e)}*/}
            {/*    placeholder={t("common.write_email")}*/}
            {/*  />*/}
            {/*  <Button*/}
            {/*    disabled={btnDisabled}*/}
            {/*    style={btnDisabled===true ? {cursor: 'not-allowed'} : {}}*/}
            {/*    onClick={handleSubmit}>*/}
            {/*    <ArrowRight color={theme.colors.background}/>*/}
            {/*  </Button>*/}
            {/*</div>*/}
            {/*<Text style={{marginTop: theme.space["3"], fontSize: '14px'}}>Klikając wyślij akceptujesz nasza Politykę Prywatności oraz wyrażasz zgodę na otrzymywanie informacji handlowych do celów marketingowych</Text>*/}
            {/*<Flex>*/}
            {/*  {*/}
            {/*    formMsg !== "" && (*/}
            {/*      <Text style={{marginTop: theme.space["3"]}}>{formMsg}</Text>*/}
            {/*    )*/}
            {/*  }*/}
            {/*</Flex>*/}

          </Box>
        </Flex>
        <Flex variant="start" responsive style={{marginTop: '8rem'}}>
          <NavLink to="/">
            <VisuallyHidden>Home</VisuallyHidden>
            <BrandLogo />
          </NavLink>
        </Flex>
        <Space size={5} />
        <Flex variant="start" responsive>
          <FlexList variant="start" responsive>
            {links &&
              links.map((link) => (
                <li key={link.id}>
                  <NavLink to={link.href}>{link.text}</NavLink>
                </li>
              ))}
          </FlexList>
          <Space />
          <FlexList>
            {meta &&
              meta.map((link) => (
                <li key={link.id}>
                  <a href={link.href} style={{color: theme.colors.primary, textDecoration: 'none'}}>
                    <Text variant="small">{link.text}</Text>
                  </a>
                </li>
              ))}
          </FlexList>
          <Text variant="small">{copyright}</Text>
        </Flex>
      </Container>
      <Space size={3} />
    </Box>
  )
}
